var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"al-action",class:'al-action--' + _vm.action,attrs:{"title":_vm.soft ? _vm.$t('auditLogs.softDeleteHint') : null}},[(_vm.soft)?_c('span',{staticClass:"al-action__soft"},[_vm._v("Soft")]):_vm._e(),_vm._v(_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }